module.exports = __webpack_public_path__ + "static/material-wrinkle-free.bb77ab63.svg";